import './ErpLinkButton.scss';
import { INTEGRATION_TYPES } from '../../constants';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ExternalLinkIcon } from '@radix-ui/react-icons';
import { Typography } from '@material-ui/core';

export default class ErpLinkButton extends Component {
    static propTypes = {
        dId: PropTypes.number.isRequired,
        onClick: PropTypes.func,
    }

    static defaultProps = {
        disabled: false,
        onClick: null,
    }

    render() {
        const { onClick, dId } = this.props;
        const erpLabel = INTEGRATION_TYPES[dId]?.label;
        const erpIcon = INTEGRATION_TYPES[dId]?.logo;
        return (
            <div className='ErpButton'>
                <button
                    type='button'
                    className={`Button ${erpLabel}`}
                    onClick={() => onClick ? onClick() : null}
                >
                    <Typography variant='subtitle2' className='GotoErpLabel'>{`Go To ${erpLabel ? erpLabel : 'ERP'} Job`}</Typography>
                    {
                        erpIcon
                            ? <img className={'Icon'} width={40} height={40} src={erpIcon} alt='erpIcon' />
                            : <ExternalLinkIcon className='Icon' />
                    }
                </button>
            </div>
        );
    }
}
